export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/business_names_slogans.b1feb73.svg";